export default "__VITE_ASSET__CJJizoLj__"